<template>
    <component :is="component" v-if="localized" :payment-plan="paymentPlan" :financed-amount-cents="financedAmountCents" />
    <div v-else class="monthlyPayment-content">
        {{
            $t("review-table.monthlyPaymentAmount", {
                formattedMonthlyPayment: formattedMonthlyPayment,
                creditTerm: creditTerm,
            })
        }}
    </div>
</template>

<script>
    import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin"
    import { formatCurrency } from "@/util/currency"

    export default {
        name: "PaymentPlanMonthlyPayment",
        mixins: [LocalizedComponentMixin],
        props: {
            financedAmountCents: {
                type: Number,
            },
            paymentPlan: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                componentType: "paymentPlanMonthlyPayment",
            }
        },
        computed: {
            formattedMonthlyPayment() {
                return formatCurrency(this.paymentPlan?.monthlyAmountCents)
            },
            creditTerm() {
                return this.paymentPlan?.durationMonths
            },
        },
    }
</script>
